<div *ngIf="typeHtml === 'user' || typeHtml === 'proposals'" class="dialog">

  <span class="title">
    {{title}}
  </span>

  <div class="line"></div>

  <div class="content">
    <div *ngIf="typeHtml === 'user'">
      <p>Informe que tipo de usuário você deseja cadastrar</p>
      <div class="container">
        <div class="group">
          <mat-label>Tipo de Usuário</mat-label>
          <mat-form-field appearance="outline" class="form__field">
            <mat-select placeholder="Selecione" [formControl]="listForm">
              <mat-option *ngFor="let item of list" [value]="item.value">
                {{item.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div *ngIf="typeHtml === 'proposals'">
      <p>Informe o tipo de proposta que você deseja cadastrar</p>
      <div class="container">
        <div class="radio__group">
          <div class="group">
            <app-tipo-setor-proposta
              [listaPropostasSetorPublico]="list"
              [listaPropostasSetorPrivado]="tiposPropostaSetorPrivado"
              (onDestroyComponent)="destroyComponent()"
              (onTipoPropostaChange)="tipoPropostaChange($event)"
              [componentInDialog]="true"
              [isSearch]="true"
              [events]="eventsSubject.asObservable()"
            >
            </app-tipo-setor-proposta>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="false">
      <p>Informe o tipo de proposta que você deseja cadastrar</p>
      <div class="container">
        <div class="radio__group">
          <p>Tipo de Produto</p>
          <mat-radio-group [formControl]="radioProposalsTypeCtrl" (change)="radioProposalsTypeSelected()">
            <mat-radio-button value="1">Setor Público</mat-radio-button>
            <!-- <mat-radio-button value="2">Setor Privado</mat-radio-button> -->
          </mat-radio-group>
        </div>
        <div class="group">
          <mat-label>Tipo de Proposta</mat-label>
          <mat-form-field appearance="outline" class="form__field">
            <mat-select placeholder="Selecione" [formControl]="listForm">
              <mat-option *ngFor="let item of list" [value]="item.value">
                {{item.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="action__dynamic">

    <button mat-raised-button class="button__white" (click)="actionFirstButton()">
      {{firstNameButton}}
    </button>

    <button mat-raised-button class="button" (click)="actionSecondButton($event)" [disabled]="!listForm.valid">
      {{secondNameButton}}
    </button>

  </div>

</div>

<div *ngIf="typeHtml === 'proposalsCommercialStructure'" class="dialog" style="width: 800px;">

  <span class="title">
    {{title}}
  </span>

  <div class="line"></div>

  <div class="content">
    <div *ngIf="typeHtml === 'proposalsCommercialStructure'">
      <p>Você poderá visualizar a estrutura comercial selecionada.</p>
      <div class="container">
        <section style="display: flex; gap: 16px;">
          <div class="group">
            <mat-label>Estrutura Comercial</mat-label>
            <mat-form-field appearance="outline" class="form__field">
              <mat-select [formControl]="commercialStructureSelected" placeholder="Selecione" value='1'>
                <mat-option *ngFor="let item of structureCommericalList" [value]="item.value" (click)="selectcommercialStructure(item.value)">
                  {{item.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="group" style="width: 100%;">
            <mat-label>Corretora</mat-label>
            <app-alert-tooltip [message]="messageTooltip" [location]="locationTooltip" [showTooltip]="showTooltip" #Tooltip (changeDisplayTooltip)="changeDisplayTooltip($event)"></app-alert-tooltip>
            <mat-form-field appearance="outline" class="form__field">
              <input matInput [matAutocomplete]="auto" [formControl]="brokerFormControl" placeholder="Busque uma corretora">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectOptionBroker($event)">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option.nmPessoa" [id]="option.cnpjCpf">
                  {{option.nmPessoa}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="brokerFormControl.hasError('insuredError')">
                Corretora selecionada não pertence a estrutura comercial.
              </mat-error>
            </mat-form-field>
          </div>
        </section>
        <div appearance="outline" class="form__field">

          <div class="data__tree">
            <app-tree [dataSource]="dataSourceTree" [treeControl]="treeControl" [selectName]="viewValue"></app-tree>
          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="" style="display: flex; justify-content: flex-end; align-items: baseline; gap: 5px">
    <button mat-raised-button class="button__white" (click)="actionFirstButton()">
      {{firstNameButton}}
    </button>
    <button mat-raised-button class="button" [disabled]="data.disableSecondButton" (click)="selectButtonOptionBroker($event)">
      {{secondNameButton}}
    </button>
  </div>

</div>
